<style>

.img{
  width: 29px;
  height: 29px;
  border-radius: 29px;
}
.img-border{
  border: 2px white solid;
}

.container{
  display: grid;
  grid-template-columns: 30px auto;
  align-items: center;
  margin-top: 5px;
  padding-top: 5px;
  border: 1px #0000 solid;
}
.icon{
  grid-column: 1;
  margin-left: 10px;
  color: gray;
}
.text{
  grid-column: 2;
  margin-left: 20px;
}

.selected{
  background-color: rgba(255,255,255,0.6);
  border: 1px white solid;
  color: black;
}

</style>

<Dialog show="{show}" title="Pick Friends" buttons="{buttons}" on:close="{cancel}" on:done="{done}">
  
  {#each allFriends as item, index}
    
    <div class="container { item.selected ? 'selected' : '' }" on:click="{ () => item.selected = !item.selected }">
      <div class="icon"><img src="/i/p/{item.oid}.jpg" class="img"></div>
      <div class="text">{item.name}</div>
    </div>
    
  {/each}
  
</Dialog>

<script>

import Dialog from "./Dialog.svelte";

export let show = false;
export let friends = [];
export let allFriends = [];

let buttons = [
  {text: "Cancel", callback: "close", disabled: false},
  {text: "Done", callback: "done", disabled: true},
];


$:{
  if (allFriends) {
    updateDone();
  }
}


// add selected object properties and associate friends with allFriends
// friends aka 'selected friends'
let allFriendsSelectedDone = false;
function updateDone() {
  // skip if already done - this is only executed once
  if (allFriendsSelectedDone == false) {
    // if allFriends doesn't have the selected property yet, add it
    for (let i in allFriends) {
      if ( ("selected" in allFriends[i]) == false ) {
        allFriends[i].selected = false;
      }
      // associate friends with allFriends selected
      if (allFriends[i].selected == false) {
        for (let j in friends) {
          if (friends[j].oid == allFriends[i].oid) {
            allFriends[i].selected = true;
          }
        }
      }
    }
    allFriendsSelectedDone = true;
  }
  
  // make sure our done button is only available if there are previously
  // selected friends
  buttons[1].disabled = true;
  for (let i in allFriends) {
    if (allFriends[i].selected == true) {
      buttons[1].disabled = false;
      break;
    }
  }
}


function cancel() {
  show = false;
}


function done() {
  friends = [];
  for (let i in allFriends) {
    if (allFriends[i].selected == true) {
      friends.push({oid: allFriends[i].oid, name: allFriends[i].name});
    }
  }
  show = false;
}


</script>